import {LocalizedString} from '../../backend/interfaces/localized-string';

/**
 * Returns a localized string but sanitized: empty values are set to undefined.
 */
export const sanitizeLocalizedString = (
  localizedString: LocalizedString
): LocalizedString | undefined => {
  let sanitizedString: LocalizedString = {};

  for (const language in localizedString) {
    if (
      localizedString[language as keyof LocalizedString] &&
      localizedString[language as keyof LocalizedString]?.trim()
    ) {
      sanitizedString[language as keyof LocalizedString] =
        localizedString[language as keyof LocalizedString]?.trim();
    }
  }

  return Object.keys(sanitizedString).length > 0 ? sanitizedString : undefined;
};

/**
 * Returns a localized string but nullified: empty values are set to null.
 */
export const nullifyLocalizedString = (
  localizedString: LocalizedString
): {[key in keyof Required<LocalizedString>]: string | null} | null => {
  let nullifiedString: {[key in keyof Required<LocalizedString>]: string | null} = {
    ptPT: null,
    esES: null,
    glES: null,
    enUS: null,
    ptBR: null,
  };
  let numberOfStrings: number = 0;

  for (const language in localizedString) {
    if (
      localizedString[language as keyof LocalizedString] &&
      localizedString[language as keyof LocalizedString]?.trim()
    ) {
      numberOfStrings += 1;
      nullifiedString[language as keyof LocalizedString] = localizedString[
        language as keyof LocalizedString
      ]?.trim() as string;
    }
  }

  return numberOfStrings > 0 ? nullifiedString : null;
};
